"use client"
import ReviewWithProfile from "src/components/film/filmwebid/ReviewWithProfile";
import theme from "src/components/themes/DefaultTheme";
import { useUserContext } from "src/lib/contexts/UserContext";
import IMovieReview from "src/lib/filmwebid/IMovieReview";
import styled, { css } from 'src/lib/styles/css';
import { useEffect, useState } from "react";


//#region [Props]
type ReviewListProps = {
	reviewList?: IMovieReview[];
	edi?: string;
	streamingId?: number;
	showAll: boolean;
	setShowReviewPanel: (showPanel: boolean) => void;
};
//#endregion

//#region [Component]
export default function ReviewList({ reviewList, edi, streamingId, showAll, setShowReviewPanel }: ReviewListProps) {
	const userContext = useUserContext();
	return reviewList?.map(r => <SReviewWithProfile
		key={r.reviewId}
		review={r}
		edi={edi}
		streamingId={streamingId}
		isLiked={!!r.isLiked}
		onTextClick={userContext.isMe(r.userId) ? () => setShowReviewPanel(true) : undefined}
		$showAll={showAll}
	/>);

}
//#endregion

//#region [Styles]
type SReviewProps = {
	$showAll: boolean;
};

const SReviewWithProfile = styled(ReviewWithProfile) <SReviewProps>`
	flex: 1 0 100%;
	@media (min-width: 550px) {
		flex: 0 0 25%;
	}

	${props => !props.$showAll ? css`
		@media (max-width: 549px) {
			&:nth-child(n + 3) {
				display: none;
			}
		}
		&:nth-child(n + 7) {
			display: none;
		}
	`: ""}
`;
//#endregion